import React from 'react'
import { useParams } from 'react-router'
import { useNavigate } from 'react-router-dom'
import parse from 'html-react-parser'

import Loading from '@/shared/components/common/Loading'
import { TYPE_NOTICEDETAIL } from '@/shared/constant/cmdtype'
import { COLOR } from '@/shared/constant/color'
import { useNoticeDetailQueryData } from '@/shared/hooks/reactquery'
import useWindowDimensions from '@/shared/hooks/useGetWindowSize'
import { convertDateFormat } from '@/shared/utils'
import { CustomBtn } from '@/styles/common/CommonForm/buttonform'
import { NoticeDetailContents, NoticeDetailWrap } from '@/styles/views/Support/Notice'

const NoticeDetailPage = () => {
  const { width } = useWindowDimensions()
  const params = Number(useParams().idx)
  const navigate = useNavigate()
  const { isLoading, data: NoticeDetailData } = useNoticeDetailQueryData(TYPE_NOTICEDETAIL, params)

  return (
    <NoticeDetailWrap>
      {isLoading && <Loading />}
      <NoticeDetailContents>
        <h3>{NoticeDetailData?.Body[0].Title}</h3>
        <span>{convertDateFormat(NoticeDetailData?.Body[0]?.RegDT)}</span>
        <div>{parse(NoticeDetailData?.Body[0]?.Contents || '')}</div>
      </NoticeDetailContents>
      <CustomBtn
        className={width > 1200 ? 'health_btn_pc' : 'health_btn_mo'}
        color={COLOR.point1}
        bgColor={COLOR.white}
        borderRadius={'40px'}
        borderColor={COLOR.point1}
        marginTop={width > 1200 ? '68px' : '38px'}
        width={width > 1200 ? '356px' : '328px'}
        height={width > 1200 ? '56px' : '44px'}
        fontSize={width > 1200 ? '18px' : '14px'}
        fontFamily={width > 1200 ? 'NanumSquareNeoHeavy, sans-serif' : 'NotoSansBold, sans-serif'}
        onClick={() => navigate('/notice')}
      >
        <span>목록보기</span>
      </CustomBtn>
    </NoticeDetailWrap>
  )
}
export default NoticeDetailPage
